import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { CommonDataSharingService } from "../common-data-sharing.service";
import { ApiCallsService } from "./api-calls.service";

@Injectable({
  providedIn: "root",
})
export class InterceptorService implements HttpInterceptor {
  constructor(
    private _apiService: ApiCallsService,
    private _commonDataService: CommonDataSharingService
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this._apiService.loader(true); // Show loader on request
    // console.log("intercepted request ... ", req);
    const token = localStorage.getItem("adminToken")
      ? localStorage.getItem("adminToken")
      : "";
    const encryptPayload =
      req?.method == "GET"
        ? null
        : this._commonDataService.encryptData(req?.body); // encrypt payload request
    if (token) {
      req = req.clone({
        headers: req.headers.set("authorization", atob(token)),
        body: encryptPayload,
      });
    } else {
      req = req.clone({
        body: encryptPayload,
      });
    }
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this._apiService.loader(false); // Hide loader on success
          // Decrypt the response body
          const decryptedBody = this._commonDataService.decryptData(event.body);

          if (req?.method == "POST") {
            return event.clone({
              body: decryptedBody,
            });
          } else {
            return event;
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        this._apiService.loader(false); // Hide loader on error
        // console.log("apiError----", error);
        const decryptError: any = this._commonDataService.JSONFormatter(
          this._commonDataService.decryptData(error?.error)
        );
        if (decryptError.statusCode == 401)
          // 401 Unauthorized
          this._apiService.errorAlert(decryptError.message, true, "");
        else this._apiService.errorAlert(decryptError.message, false, "");
        return throwError(() => decryptError);
      })
    );
  }
}
